import React, { useEffect, useState } from "react";

const links = [
  { href: "#story", label: "Story" },
  { href: "#concept", label: "Kitchens" },
  { href: "#menu", label: "Menu" },
  { href: "#gallery", label: "Inside" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
    // Mount-only: attaches a single scroll listener. setScrolled is stable.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <nav className={`nav${scrolled ? " scrolled" : ""}`} id="siteNav">
        <div className="wrap">
          <a href="#top" className="nav-logo" aria-label="Cloud9 home">
            <img src="/cloud9-logo-v2.png" alt="Cloude 9 Café" className="nav-logo-img" />
          </a>
          <ul className="nav-links">
            {links.map((l) => (
              <li key={l.href}>
                <a href={l.href}>{l.label}</a>
              </li>
            ))}
            <li>
              <a href="#reserve" className="nav-cta">
                Reserve
              </a>
            </li>
          </ul>
          <button className="nav-burger" onClick={() => setOpen(true)}>
            Menu
          </button>
        </div>
      </nav>

      <div className={`nav-mobile${open ? " open" : ""}`} onClick={() => setOpen(false)}>
        {links.map((l) => (
          <a key={l.href} href={l.href}>
            {l.label}
          </a>
        ))}
        <a href="#reserve">Reserve</a>
      </div>
    </>
  );
}
